<template>
  <div v-if="show" class="absolute top-full right-0 mt-2 w-80 bg-n-surface-1 border border-n-weak rounded-xl shadow-xl z-50 overflow-hidden" @click.stop>
    <div class="max-h-96 overflow-y-auto p-3 space-y-3">
      <div v-for="account in groupedAccounts" :key="account.email" class="space-y-1">
        <div class="text-[11px] font-semibold text-n-slate-9 uppercase tracking-wider px-1">
          {{ account.email }}
        </div>
        <div 
          v-for="cal in account.calendars" 
          :key="cal.id"
          class="flex items-center gap-3 px-2 py-1.5 rounded-lg hover:bg-n-alpha-1 cursor-pointer transition-colors"
          @click="$emit('toggle', cal.id)"
        >
          <div 
            class="size-4 rounded border-2 flex items-center justify-center transition-colors"
            :style="{ 
              backgroundColor: cal.selected ? cal.color : 'transparent', 
              borderColor: cal.color 
            }"
          >
            <span v-if="cal.selected" class="i-lucide-check size-2.5 text-white" />
          </div>
          <span class="text-sm text-n-slate-12 flex-1 truncate">{{ cal.name }}</span>
          <span v-if="cal.is_default" class="text-[10px] text-n-slate-9 font-medium">Principal</span>
        </div>
      </div>
    </div>

    <div class="border-t border-n-weak p-2">
      <button 
        class="w-full flex items-center gap-2 px-3 py-2 text-sm rounded-lg transition-colors"
        :class="canManageSettings ? 'text-n-slate-11 hover:bg-n-alpha-1' : 'text-n-slate-9 opacity-60 cursor-not-allowed'"
        :disabled="!canManageSettings"
        @click="canManageSettings && $emit('manage')"
      >
        <span class="i-lucide-settings size-4" />
        Gerenciar contas
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarPopover',
  props: {
    show: { type: Boolean, default: false },
    calendars: { type: Array, default: () => [] },
    connectedAccounts: { type: Array, default: () => [] },
    canManageSettings: { type: Boolean, default: false },
  },
  emits: ['toggle', 'manage'],
  computed: {
    groupedAccounts() {
      // Group calendars by connected account email
      if (this.connectedAccounts.length > 0) {
        return this.connectedAccounts.map(acc => ({
          email: acc.email,
          calendars: this.calendars.filter(c => c.hook_id === acc.id),
        })).filter(g => g.calendars.length > 0);
      }
      // Fallback: single group
      return [{ email: 'Meus Calendários', calendars: this.calendars }];
    },
  },
};
</script>
